<script>
	import { getContext, onDestroy } from 'svelte'
	import { slide } from 'svelte/transition'
	import { styles } from '../../library/scripts/styles'
	import { storeElementID, storeData, storeSelectedIcon, storeAnimate } from '../../library/scripts/Store.svelte'
	import { get_initial_values, get_element_tags, string_to_fontsize, get_blocks } from '../builderUtils'
	import { reorder_layout } from '../../library/scripts/utils'
	import ColorSelector from '../ColorSelector.svelte'
	import SelectValues from '../SelectValues.svelte'
	import SizeSelector from '../SizeSelector.svelte'
	import Shader from '../../library/ShadersAndSpinners/Shader.svelte'
	import Spinner from '../../library/ShadersAndSpinners/SpinnerCircle.svelte'

	export let width

	const globals = getContext('globals')
	const fsS = globals.fsS
	const fsXS = globals.fsXS
	const icon = globals.icon
	const iconColor = globals.colorDark
	const iconHover = globals.colorError
	let iconTWeight = globals.colorDark
	let iconTStyle = globals.colorDark
	let iconTXTWeight = globals.colorDark
	let iconTXTStyle = globals.colorDark
	let iconTLeft = globals.colorDark
	let iconTCenter = globals.colorDark
	let iconTJustify = globals.colorDark
	let iconTRight = globals.colorDark
	let mainTool = globals.mainTool
	let subTool = globals.subTool

	let mainToolHover = globals.mainToolHover
	let subToolHover = globals.subToolHover

	const fontFamily = globals.fontFamily

	const fontSize = globals.fontSize

	let elementID
	let config
	let blocks
	let blockID

	//show hide tool
	let generalTool1 = false
	let generalTool2 = false
	let showTool0 = false
	let showTool1 = false
	let showTool2 = false
	let showTool3 = false
	let showTool4 = false
	let showTool5 = false
	let showTool6 = false
	let showTool7 = false
	let showTool8 = false
	let showTool9 = false

	//the selectedIcon from store
	let selectedStoreIcon

	//change layout order
	let shaderChangeOrder = false

	//the values to send to sizeSelectors
	let selectedBorderWidth
	let selectedInsetBorderWidth
	let selectedInsetBorderColor
	let selectedInsetBorderOpac
	let selectedInsetBBradius
	let selectedSpeed
	let selectedPause

	//css selections
	let selectedBorderColor = 'hsla(0,0%,0%,1)'
	let selectedBackground
	let selectedColor
	let selectedBgOpac
	let selectedMarginTop
	let selectedMarginBottom
	let selectedPadding
	let selectedBLwidth
	let selectedBLcolor
	let selectedBTwidth
	let selectedBTcolor
	let selectedBRwidth
	let selectedBRcolor
	let selectedBBwidth
	let selectedBBcolor
	let selectedBTradius
	let selectedBBradius
	let selectedSliderWidth
	let selectedSliderHeight
	let selectedInsetWidth
	let selectedInsetHeight
	let selectedInsetLeft
	let selectedInsetTop
	let selectedInsetBackground
	let selectedInsetBgOpac
	let selectedIBLwidth
	let selectedIBLcolor
	let selectedIBTwidth
	let selectedIBTcolor
	let selectedIBRwidth
	let selectedIBRcolor
	let selectedIBBwidth
	let selectedIBBcolor
	let selectedITradius
	let selectedIBradius
	let selectedItitleFont
	let selectedItitleColor
	let selectedItitleSize
	let selectedItitleWeight
	let selectedItitleStyle
	let selectedItitleOpac
	let selectedItextFont
	let selectedItextColor
	let selectedItextSize
	let selectedItextAlign
	let selectedItextWeight
	let selectedItextStyle
	let selectedItextOpac
	let selectedSBLwidth
	let selectedSBLcolor
	let selectedSBTwidth
	let selectedSBTcolor
	let selectedSBRwidth
	let selectedSBRcolor
	let selectedSBBwidth
	let selectedSBBcolor
	let selectedSBTradius
	let selectedSBBradius
	let selectedSliderShadowColor
	let selectedSliderShadowOpac
	let selectedSliderShadowX
	let selectedSliderShadowY
	let selectedSliderShadowBlur
	let selectedSliderInsetShadowColor
	let selectedSliderInsetShadowOpac
	let selectedSliderInsetShadowX
	let selectedSliderInsetShadowY
	let selectedSliderInsetShadowBlur
	let controlColor
	let controlHover

	//icon selected
	let selectedIcon
	let selectedIicon

	//set icons
	let icon1 = false
	let icon2 = false
	let icon3 = false
	let icon4 = false
	let icon5 = false
	let icon6 = false
	let icon7 = false
	let icon8 = false
	let icon9 = false
	let icon10 = false

	let icon1Color = iconColor
	let icon2Color = iconColor
	let icon3Color = iconColor
	let icon4Color = iconColor
	let icon5Color = iconColor
	let icon6Color = iconColor
	let icon7Color = iconColor
	let icon8Color = iconColor
	let icon9Color = iconColor
	let icon10Color = iconColor

	//stative ID for getElementById in SelectValues
	let idSelect1 = 'selFont'
	let idSelect2 = 'selSize'
	let idSelect3 = 'selFont_1'
	let idSelect4 = 'selSize_2'
	const idColor1 = '100'
	const idColor2 = '101'
	const idColor3 = '102'
	const idColor4 = '103'
	const idColor5 = '104'
	const idColor6 = '105'
	const idColor7 = '106'
	const idColor8 = '107'
	const idColor9 = '108'
	const idColor10 = '109'
	const idMarginTop = '3'
	const idMarginBottom = '4'
	const idPadding = '5'
	const idBorderWidth = '6'
	const idInsetBorderWidth = '23'
	const idBTradius = '7'
	const idInsetBTradius = '24'
	const idBBradius = '8'
	const idInsetBBradius = '25'
	const idSliderWidth = '18'
	const idSliderHeight = '28'
	const idInsetWidth = '19'
	const idInsetHeight = '20'
	const idInsetLeft = '21'
	const idInsetTop = '22'
	const idSliderSpeed = '26'
	const idSliderPause = '27'
	const idSliderOffsetX = '9'
	const idSliderOffsetY = '10'
	const idSliderBlur = '11'
	const idSliderInsetOffsetX = '12'
	const idSliderInsetOffsetY = '13'
	const idSliderInsetBlur = '14'

	//show border tools
	let iconSelected = false

	//slider inset (text window)
	let iconIselected = false

	//animation
	let autoplay
	const stoAnimate = storeAnimate.subscribe((value) => {
		autoplay = value
	})

	const stoData = storeData.subscribe((value) => {
		if (value) {
			config = value
			blocks = value.blocks
		}
	})

	const stoElementID = storeElementID.subscribe((value) => {
		elementID = value
	})

	const stoSelectedIcon = storeSelectedIcon.subscribe((value) => {
		selectedStoreIcon = value
	})

	//set the initial css values from config.json
	$: if (elementID === 'cover-slider') {
		const tags = get_element_tags(elementID)
		blockID = tags[0]
		const values = get_initial_values(elementID, blocks, tags)
		selectedBackground = values[0]
		selectedBgOpac = values[1]
		selectedMarginTop = values[2]
		selectedMarginBottom = values[3]
		selectedPadding = values[4]
		selectedBLwidth = values[5]
		selectedBLcolor = values[6]
		selectedBTwidth = values[7]
		selectedBTcolor = values[8]
		selectedBRwidth = values[9]
		selectedBRcolor = values[10]
		selectedBBwidth = values[11]
		selectedBBcolor = values[12]
		selectedBTradius = values[13]
		selectedBBradius = values[14]
		selectedSliderWidth = values[20][0]
		selectedSliderHeight = values[20][1]
		selectedInsetWidth = values[20][2]
		selectedInsetHeight = values[20][3]
		selectedInsetLeft = values[20][4]
		selectedInsetTop = values[20][5]
		selectedInsetBackground = values[20][6]
		selectedInsetBgOpac = values[20][7]
		selectedIBLwidth = values[20][8]
		selectedIBLcolor = values[20][9]
		selectedIBTwidth = values[20][10]
		selectedIBTcolor = values[20][11]
		selectedIBRwidth = values[20][12]
		selectedIBRcolor = values[20][13]
		selectedIBBwidth = values[20][14]
		selectedIBBcolor = values[20][20]
		selectedITradius = values[20][16]
		selectedIBradius = values[20][17]
		selectedSpeed = values[20][18]
		selectedPause = values[20][20]
		selectedItitleFont = values[20][20]
		selectedItitleColor = values[20][21]
		selectedItitleSize = values[20][22]
		selectedItitleWeight = values[20][23]
		selectedItitleStyle = values[20][24]
		set_fontstyle_initial_value('title', selectedItitleWeight, selectedItitleStyle)
		selectedItextFont = values[20][25]
		selectedItextColor = values[20][26]
		selectedItextSize = values[20][27]
		selectedItextAlign = set_inset_text_align_initial_value(values[20][28])
		selectedItextWeight = values[20][29]
		selectedItextStyle = values[20][30]
		set_fontstyle_initial_value('text', selectedItextWeight, selectedItextStyle)
		selectedItitleOpac = values[20][31]
		selectedItextOpac = values[20][32]
		selectedSBLwidth = values[20][33]
		selectedSBLcolor = values[20][34]
		selectedSBTwidth = values[20][35]
		selectedSBTcolor = values[20][36]
		selectedSBRwidth = values[20][37]
		selectedSBRcolor = values[20][38]
		selectedSBBwidth = values[20][39]
		selectedSBBcolor = values[20][40]
		selectedSBTradius = values[20][41]
		selectedSBBradius = values[20][42]
		selectedSliderShadowColor = values[20][43]
		selectedSliderShadowOpac = values[20][44]
		selectedSliderShadowX = values[20][45]
		selectedSliderShadowY = values[20][46]
		selectedSliderShadowBlur = values[20][47]
		selectedSliderInsetShadowColor = values[20][48]
		selectedSliderInsetShadowOpac = values[20][49]
		selectedSliderInsetShadowX = values[20][50]
		selectedSliderInsetShadowY = values[20][51]
		selectedSliderInsetShadowBlur = values[20][52]
		controlColor = values[20][53]
		controlHover = values[20][54]

		if (selectedSBLwidth > 0) {
			icon1 = true
			set_icon_color('left', 1)
		}
		if (selectedSBTwidth > 0) {
			icon2 = true
			set_icon_color('top', 2)
		}

		if (selectedSBRwidth > 0) {
			icon3 = true
			set_icon_color('right', 3)
		}

		if (selectedSBBwidth > 0) {
			icon4 = true
			set_icon_color('bottom', 4)
		}

		if (selectedSBLwidth > 0 && selectedSBTwidth > 0 && selectedSBRwidth > 0 && selectedSBBwidth > 0) {
			icon1 = true
			icon2 = true
			icon3 = true
			icon4 = true
			icon5 = true
			set_icon_color('all', 5)
		}

		if (selectedIBLwidth > 0) {
			icon6 = true
			set_icon_color('left', 6)
		}
		if (selectedIBTwidth > 0) {
			icon7 = true
			set_icon_color('top', 7)
		}

		if (selectedIBRwidth > 0) {
			icon8 = true
			set_icon_color('right', 8)
		}

		if (selectedIBBwidth > 0) {
			icon9 = true
			set_icon_color('bottom', 9)
		}

		if (selectedIBLwidth > 0 && selectedIBTwidth > 0 && selectedIBRwidth > 0 && selectedIBBwidth > 0) {
			icon6 = true
			icon7 = true
			icon8 = true
			icon9 = true
			icon10 = true
			set_icon_color('all', 10)
		}
	}

	$: if (!icon1 && !icon2 && !icon3 && !icon4 && !icon5) iconSelected = false
	$: if (!icon6 && !icon7 && !icon8 && !icon9 && !icon10) iconIselected = false

	$: if (selectedStoreIcon === 'icon1') selectedBorderWidth = selectedSBLwidth
	$: if (selectedStoreIcon === 'icon2') selectedBorderWidth = selectedSBTwidth
	$: if (selectedStoreIcon === 'icon3') selectedBorderWidth = selectedSBRwidth
	$: if (selectedStoreIcon === 'icon4') selectedBorderWidth = selectedSBBwidth
	$: if (selectedStoreIcon === 'icon5') selectedBorderWidth = selectedSBLwidth
	$: if (selectedStoreIcon === 'icon6') selectedInsetBorderWidth = selectedIBLwidth
	$: if (selectedStoreIcon === 'icon7') selectedInsetBorderWidth = selectedIBTwidth
	$: if (selectedStoreIcon === 'icon8') selectedInsetBorderWidth = selectedIBRwidth
	$: if (selectedStoreIcon === 'icon9') selectedInsetBorderWidth = selectedIBBwidth
	$: if (selectedStoreIcon === 'icon10') selectedInsetBorderWidth = selectedIBLwidth

	const set_icon_color = (c, iNum) => {
		if (c === 'left') {
			if (iNum === 1) icon1Color = iconHover
			if (iNum === 6) icon6Color = iconHover
		}
		if (c === 'top') {
			if (iNum === 2) icon2Color = iconHover
			if (iNum === 7) icon7Color = iconHover
		}
		if (c === 'right') {
			if (iNum === 3) icon3Color = iconHover
			if (iNum === 8) icon8Color = iconHover
		}
		if (c === 'bottom') {
			if (iNum === 4) icon4Color = iconHover
			if (iNum === 9) icon9Color = iconHover
		}
		if (c === 'all') {
			if (iNum === 5) {
				icon1Color = iconHover
				icon2Color = iconHover
				icon3Color = iconHover
				icon4Color = iconHover
				icon5Color = iconHover
			}

			if (iNum === 10) {
				icon6Color = iconHover
				icon7Color = iconHover
				icon8Color = iconHover
				icon9Color = iconHover
				icon10Color = iconHover
			}
		}
		if (c === 'none') {
			if (iNum === 5) {
				icon1Color = iconColor
				icon2Color = iconColor
				icon3Color = iconColor
				icon4Color = iconColor
				icon5Color = iconColor
			}
			if (iNum === 10) {
				icon6Color = iconColor
				icon7Color = iconColor
				icon8Color = iconColor
				icon9Color = iconColor
				icon10Color = iconColor
			}
		}
	}

	const set_inset_text_align_initial_value = (v) => {
		if (v === 'left') {
			iconTLeft = iconHover
			iconTCenter = iconColor
			iconTRight = iconColor
			iconTJustify = iconColor
		}
		if (v === 'center') {
			iconTLeft = iconColor
			iconTCenter = iconHover
			iconTRight = iconColor
			iconTJustify = iconColor
		}
		if (v === 'right') {
			iconTLeft = iconColor
			iconTCenter = iconColor
			iconTRight = iconHover
			iconTJustify = iconColor
		}
		if (v === 'justify') {
			iconTLeft = iconColor
			iconTCenter = iconColor
			iconTRight = iconColor
			iconTJustify = iconHover
		}
	}

	const set_fontstyle_initial_value = (c, w, s) => {
		if (c === 'title') {
			if (w === 'bold') iconTWeight = iconHover
			if (w === 'normal') iconTWeight = iconColor
			if (s === 'italic') iconTStyle = iconHover
			if (s === 'normal') iconTStyle = iconColor
		}

		if (c === 'text') {
			if (w === 'bold') iconTXTWeight = iconHover
			if (w === 'normal') iconTXTWeight = iconColor
			if (s === 'italic') iconTXTStyle = iconHover
			if (s === 'normal') iconTXTStyle = iconColor
		}
	}

	const set_css_tag = (cssTag, cmd) => {
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				if (cmd === 'bg') block.backgroundColor = cssTag
				if (cmd === 'cC') block.controlC = cssTag
				if (cmd === 'cH') block.controlH = cssTag

				if (cmd === 'fontTitle') block.sliderInsetTitleFont = cssTag
				if (cmd === 'sizeTitle') block.sliderInsetTitleSize = cssTag
				if (cmd === 'fontText') block.sliderInsetTextFont = cssTag
				if (cmd === 'sizeText') block.sliderInsetTextSize = cssTag
				if (cmd === 'insetTitleColor') block.sliderInsetTitleColor = cssTag
				if (cmd === 'insetTextColor') block.sliderInsetTextColor = cssTag
				if (cmd === 'insetTitleWeight') {
					block.sliderInsetTitleWeight = block.sliderInsetTitleWeight === 'bold' ? 'normal' : 'bold'
				}

				if (cmd === 'insetTitleStyle') {
					block.sliderInsetTitleStyle = block.sliderInsetTitleStyle === 'italic' ? 'normal' : 'italic'
				}

				if (cmd === 'insetTextWeight') {
					block.sliderInsetTextWeight = block.sliderInsetTextWeight === 'bold' ? 'normal' : 'bold'
				}

				if (cmd === 'insetTextStyle') {
					block.sliderInsetTextStyle = block.sliderInsetTextStyle === 'italic' ? 'normal' : 'italic'
				}

				if (cmd === 'insetTextAlign') block.sliderInsetTextAlign = cssTag

				if (cmd === 'insetBg') {
					block.sliderInsetBg = cssTag
				}

				if (cmd === 'bL') {
					if (icon1 && selectedIcon === 'icon1') {
						block.sliderBLcolor = cssTag
						block.sliderBLwidth = '1'
						icon1Color = iconHover
						if (icon1 && icon2 && icon3 && icon4) icon5Color = iconHover
					} else {
						block.sliderBLwidth = '0'
						icon1Color = iconColor
						icon5Color = iconColor
					}
				}

				if (cmd === 'bIL') {
					if (icon6 && selectedIicon === 'icon6') {
						block.sliderInsetBLcolor = cssTag
						block.sliderInsetBLwidth = '1'
						icon6Color = iconHover
						if (icon6 && icon7 && icon8 && icon9) icon10Color = iconHover
					} else {
						block.sliderInsetBLwidth = '0'
						icon6Color = iconColor
						icon10Color = iconColor
					}
				}

				if (cmd === 'bT') {
					if (icon2 && selectedIcon === 'icon2') {
						block.sliderBTcolor = cssTag
						block.sliderBTwidth = '1'
						icon2Color = iconHover
						if (icon1 && icon2 && icon3 && icon4) icon5Color = iconHover
					} else {
						block.sliderBTwidth = '0'
						icon2Color = iconColor
						icon5Color = iconColor
					}
				}

				if (cmd === 'bIT') {
					if (icon7 && selectedIicon === 'icon7') {
						block.sliderInsetBTcolor = cssTag
						block.sliderInsetBTwidth = '1'
						icon7Color = iconHover
						if (icon6 && icon7 && icon8 && icon9) icon10Color = iconHover
					} else {
						block.sliderInsetBTwidth = '0'
						icon7Color = iconColor
						icon10Color = iconColor
					}
				}

				if (cmd === 'bR') {
					if (icon3 && selectedIcon === 'icon3') {
						block.sliderBRcolor = cssTag
						block.sliderBRwidth = '1'
						icon3Color = iconHover
						if (icon1 && icon2 && icon3 && icon4) icon5Color = iconHover
					} else {
						block.sliderBRwidth = '0'
						icon3Color = iconColor
						icon5Color = iconColor
					}
				}

				if (cmd === 'bIR') {
					if (icon8 && selectedIicon === 'icon8') {
						block.sliderInsetBRcolor = cssTag
						block.sliderInsetBRwidth = '1'
						icon8Color = iconHover
						if (icon6 && icon7 && icon8 && icon9) icon10Color = iconHover
					} else {
						block.sliderInsetBRwidth = '0'
						icon8Color = iconColor
						icon10Color = iconColor
					}
				}

				if (cmd === 'bB') {
					if (icon4 && selectedIcon === 'icon4') {
						block.sliderBBcolor = cssTag
						block.sliderBBwidth = '1'
						icon4Color = iconHover
						if (icon1 && icon2 && icon3 && icon4) icon5Color = iconHover
					} else {
						block.sliderBBwidth = '0'
						icon4Color = iconColor
						icon5Color = iconColor
					}
				}

				if (cmd === 'bIB') {
					if (icon9 && selectedIicon === 'icon9') {
						block.sliderInsetBBcolor = cssTag
						block.sliderInsetBBwidth = '1'
						icon9Color = iconHover
						if (icon6 && icon7 && icon8 && icon9) icon10Color = iconHover
					} else {
						block.sliderInsetBBwidth = '0'
						icon9Color = iconColor
						icon10Color = iconColor
					}
				}

				if (cmd === 'bA') {
					if (icon5 && selectedIcon === 'icon5') {
						block.sliderBLcolor = cssTag
						block.sliderBLwidth = '1'
						block.sliderBTcolor = cssTag
						block.sliderBTwidth = '1'
						block.sliderBRcolor = cssTag
						block.sliderBRwidth = '1'
						block.sliderBBcolor = cssTag
						block.sliderBBwidth = '1'
						icon5Color = iconHover
						icon1Color = iconHover
						icon2Color = iconHover
						icon3Color = iconHover
						icon4Color = iconHover
					} else {
						block.sliderBLwidth = '0'
						block.sliderBTwidth = '0'
						block.sliderBRwidth = '0'
						block.sliderBBwidth = '0'
						icon5Color = iconColor
						icon1Color = iconColor
						icon2Color = iconColor
						icon3Color = iconColor
						icon4Color = iconColor

						icon1 = false
						icon2 = false
						icon3 = false
						icon4 = false
						icon5 = false
					}
				}

				if (cmd === 'bIA') {
					if (icon10 && selectedIicon === 'icon10') {
						block.sliderInsetBLcolor = cssTag
						block.sliderInsetBLwidth = '1'
						block.sliderInsetBTcolor = cssTag
						block.sliderInsetBTwidth = '1'
						block.sliderInsetBRcolor = cssTag
						block.sliderInsetBRwidth = '1'
						block.sliderInsetBBcolor = cssTag
						block.sliderInsetBBwidth = '1'
						icon10Color = iconHover
						icon6Color = iconHover
						icon7Color = iconHover
						icon8Color = iconHover
						icon9Color = iconHover
					} else {
						block.sliderInsetBLwidth = '0'
						block.sliderInsetBTwidth = '0'
						block.sliderInsetBRwidth = '0'
						block.sliderInsetBBwidth = '0'
						icon10Color = iconColor
						icon6Color = iconColor
						icon7Color = iconColor
						icon8Color = iconColor
						icon9Color = iconColor
						icon6 = false
						icon7 = false
						icon8 = false
						icon9 = false
						icon10 = false
					}
				}

				if (cmd === 'bWidth') {
					if (icon1 && selectedIcon === 'icon1') block.sliderBLwidth = cssTag
					if (icon2 && selectedIcon === 'icon2') block.sliderBTwidth = cssTag
					if (icon3 && selectedIcon === 'icon3') block.sliderBRwidth = cssTag
					if (icon4 && selectedIcon === 'icon4') block.sliderBBwidth = cssTag
					if (icon5 && selectedIcon === 'icon5') {
						block.sliderBLwidth = cssTag
						block.sliderBTwidth = cssTag
						block.sliderBRwidth = cssTag
						block.sliderBBwidth = cssTag
					}
				}

				if (cmd === 'bIWidth') {
					if (icon6 && selectedIicon === 'icon6') {
						block.sliderInsetBLwidth = cssTag
					}
					if (icon7 && selectedIicon === 'icon7') block.sliderInsetBTwidth = cssTag
					if (icon8 && selectedIicon === 'icon8') block.sliderInsetBRwidth = cssTag
					if (icon9 && selectedIicon === 'icon9') block.sliderInsetBBwidth = cssTag
					if (icon10 && selectedIicon === 'icon10') {
						block.sliderInsetBLwidth = cssTag
						block.sliderInsetBTwidth = cssTag
						block.sliderInsetBRwidth = cssTag
						block.sliderInsetBBwidth = cssTag
					}
				}

				if (cmd === 'bColor' || cmd === 'bOpacity') {
					if (icon1 && selectedIcon === 'icon1') block.sliderBLcolor = cssTag
					if (icon2 && selectedIcon === 'icon2') block.sliderBTcolor = cssTag
					if (icon3 && selectedIcon === 'icon3') block.sliderBRcolor = cssTag
					if (icon4 && selectedIcon === 'icon4') block.sliderBBcolor = cssTag
					if (icon5 && selectedIcon === 'icon5') {
						block.sliderBLcolor = cssTag
						block.sliderBTcolor = cssTag
						block.sliderBRcolor = cssTag
						block.sliderBBcolor = cssTag
					}
				}

				if (cmd === 'bIColor') {
					if (icon6 && selectedIicon === 'icon6') block.sliderInsetBLcolor = cssTag
					if (icon7 && selectedIicon === 'icon7') block.sliderInsetBTcolor = cssTag
					if (icon8 && selectedIicon === 'icon8') block.sliderInsetBRcolor = cssTag
					if (icon9 && selectedIicon === 'icon9') block.sliderInsetBBolor = cssTag
					if (icon10 && selectedIicon === 'icon10') {
						block.sliderInsetBLcolor = cssTag
						block.sliderInsetBTcolor = cssTag
						block.sliderInsetBRcolor = cssTag
						block.sliderInsetBBcolor = cssTag
					}
				}

				if (cmd === 'btRadius') {
					block.sliderBTradius = cssTag
				}

				if (cmd === 'btIradius') {
					block.sliderInsetBTradius = cssTag
				}

				if (cmd === 'bbRadius') {
					block.sliderBBradius = cssTag
				}

				if (cmd === 'bbIradius') {
					block.sliderInsetBBradius = cssTag
				}

				if (cmd === 'sliderScolor') {
					block.sliderShadowColor = cssTag
				}

				if (cmd === 'sliderInsetShadowColor') {
					block.sliderInsetShadowColor = cssTag
				}

				if (cmd === 'sliderSoffsetX') {
					block.sliderShadowOffsetX = cssTag
				}

				if (cmd === 'sliderInsetSoffsetX') {
					block.sliderInsetShadowOffsetX = cssTag
				}

				if (cmd === 'sliderSoffsetY') {
					block.sliderShadowOffsetY = cssTag
				}

				if (cmd === 'sliderInsetSoffsetY') {
					block.sliderInsetShadowOffsetY = cssTag
				}

				if (cmd === 'sliderSblur') {
					block.sliderShadowBlur = cssTag
				}

				if (cmd === 'sliderInsetSblur') {
					block.sliderInsetShadowBlur = cssTag
				}
			}
		})

		config.blocks = blocks
		storeData.set(config)
	}

	const set_bg_color = (e) => {
		set_css_tag(e.detail.color, 'bg')
	}

	const set_control_color = (e) => {
		set_css_tag(e.detail.color, 'cC')
	}

	const set_control_hover = (e) => {
		set_css_tag(e.detail.color, 'cH')
	}

	const set_inset_bg_color = (e) => {
		set_css_tag(e.detail.color, 'insetBg')
	}

	const set_inset_title_color = (e) => {
		set_css_tag(e.detail.color, 'insetTitleColor')
	}

	const set_inset_text_color = (e) => {
		set_css_tag(e.detail.color, 'insetTextColor')
	}

	const set_border_color = (e) => {
		set_css_tag(e.detail.color, 'bColor')
	}

	const set_inset_border_color = (e) => {
		set_css_tag(e.detail.color, 'bIColor')
	}

	const set_border_width = (e) => {
		set_css_tag(e.detail.value, 'bWidth')
	}

	const set_inset_border_width = (e) => {
		set_css_tag(e.detail.value, 'bIWidth')
	}

	const set_border_top_radius = (e) => {
		set_css_tag(e.detail.value, 'btRadius')
	}

	const set_inset_border_top_radius = (e) => {
		set_css_tag(e.detail.value, 'btIradius')
	}

	const set_border_bottom_radius = (e) => {
		set_css_tag(e.detail.value, 'bbRadius')
	}

	const set_inset_border_bottom_radius = (e) => {
		set_css_tag(e.detail.value, 'bbIradius')
	}

	const set_inset_title_font_weight = () => {
		set_css_tag(null, 'insetTitleWeight')
	}

	const set_inset_title_font_style = () => {
		set_css_tag(null, 'insetTitleStyle')
	}

	const set_inset_text_font_weight = () => {
		set_css_tag(null, 'insetTextWeight')
	}

	const set_inset_text_font_style = () => {
		set_css_tag(null, 'insetTextStyle')
	}

	const set_inset_text_font_align = (a) => {
		set_css_tag(a, 'insetTextAlign')
	}

	const change_direction = (d) => {
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.sliderDirection = d
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const change_speed = (e) => {
		let speed
		switch (e.detail.value) {
			case 0:
				speed = 7000
				break
			case 1:
				speed = 6000
				break

			case 2:
				speed = 5000
				break

			case 3:
				speed = 4000
				break

			case 4:
				speed = 3000
				break

			case 5:
				speed = 2000
				break
		}
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.sliderSpeed = speed
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const change_pause = (e) => {
		let pause
		switch (e.detail.value) {
			case 0:
				pause = 2
				break
			case 1:
				pause = 3
				break

			case 2:
				pause = 4
				break

			case 3:
				pause = 5
				break

			case 4:
				pause = 6
				break

			case 5:
				pause = 7
				break
		}
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.sliderPause = pause
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const set_icon_1 = () => {
		iconSelected = true
		selectedIcon = 'icon1'
		storeSelectedIcon.set('icon1')
		icon1 = icon1 === false ? true : false
		if (icon1) icon1Color = iconHover
		else icon1Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bL')
	}

	const set_icon_2 = () => {
		iconSelected = true
		selectedIcon = 'icon2'
		storeSelectedIcon.set('icon2')
		icon2 = icon2 === false ? true : false
		if (icon2) icon2Color = iconHover
		else icon2Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bT')
	}

	const set_icon_3 = () => {
		iconSelected = true
		selectedIcon = 'icon3'
		storeSelectedIcon.set('icon3')
		icon3 = icon3 === false ? true : false
		if (icon3) icon3Color = iconHover
		else icon3Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bR')
	}

	const set_icon_4 = () => {
		iconSelected = true
		selectedIcon = 'icon4'
		storeSelectedIcon.set('icon4')
		icon4 = icon4 === false ? true : false
		if (icon4) icon4Color = iconHover
		else icon4Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bB')
	}

	const set_icon_5 = () => {
		iconSelected = true
		selectedIcon = 'icon5'
		storeSelectedIcon.set('icon5')
		icon5 = icon5 === false ? true : false
		if (icon5) icon5Color = iconHover
		else icon5Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bA')
	}

	const set_icon_6 = () => {
		iconIselected = true
		selectedIicon = 'icon6'
		storeSelectedIcon.set('icon6')
		icon6 = icon6 === false ? true : false
		if (icon6) icon6Color = iconHover
		else icon6Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bIL')
	}

	const set_icon_7 = () => {
		iconIselected = true
		selectedIicon = 'icon7'
		storeSelectedIcon.set('icon7')
		icon7 = icon7 === false ? true : false
		if (icon7) icon7Color = iconHover
		else icon7Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bIT')
	}

	const set_icon_8 = () => {
		iconIselected = true
		selectedIicon = 'icon8'
		storeSelectedIcon.set('icon8')
		icon8 = icon8 === false ? true : false
		if (icon8) icon8Color = iconHover
		else icon8Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bIR')
	}

	const set_icon_9 = () => {
		iconIselected = true
		selectedIicon = 'icon9'
		storeSelectedIcon.set('icon9')
		icon9 = icon9 === false ? true : false
		if (icon9) icon9Color = iconHover
		else icon9Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bIB')
	}

	const set_icon_10 = () => {
		iconIselected = true
		selectedIicon = 'icon10'
		storeSelectedIcon.set('icon10')
		icon10 = icon10 === false ? true : false
		if (icon10) icon10Color = iconHover
		else icon10Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bIA')
	}

	const set_margin_top = (e) => {
		const value = e.detail.value
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.marginTop = value
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const set_margin_bottom = (e) => {
		const value = e.detail.value
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.marginBottom = value
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const set_padding = (e) => {
		const value = e.detail.value
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.padding = value
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const set_slider_shadow_color = (e) => {
		set_css_tag(e.detail.color, 'sliderScolor')
	}

	const set_slider_window_shadow_color = (e) => {
		set_css_tag(e.detail.color, 'sliderInsetShadowColor')
	}

	const set_slider_offset_x = (e) => {
		set_css_tag(e.detail.value, 'sliderSoffsetX')
	}

	const set_slider_inset_offset_x = (e) => {
		set_css_tag(e.detail.value, 'sliderInsetSoffsetX')
	}

	const set_slider_offset_y = (e) => {
		set_css_tag(e.detail.value, 'sliderSoffsetY')
	}

	const set_slider_inset_offset_y = (e) => {
		set_css_tag(e.detail.value, 'sliderInsetSoffsetY')
	}

	const set_slider_blur = (e) => {
		set_css_tag(e.detail.value, 'sliderSblur')
	}

	const set_slider_inset_blur = (e) => {
		set_css_tag(e.detail.value, 'sliderInsetSblur')
	}

	const set_slider_width = (e) => {
		const value = e.detail.value
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.sliderWidth = value
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const set_slider_height = (e) => {
		const value = e.detail.value
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.sliderHeight = value
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const set_inset_width = (e) => {
		const value = e.detail.value
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.sliderInsetWidth = value
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const set_inset_height = (e) => {
		const value = e.detail.value
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.sliderInsetHeight = value
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const set_inset_left = (e) => {
		const value = e.detail.value
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.sliderInsetLeft = value
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const set_inset_top = (e) => {
		const value = e.detail.value
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.sliderInsetTop = value
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const auto_play = (cmd) => {
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				if (cmd === 'off') {
					block.sliderAutoPlay = 'false'
					storeAnimate.set('false')
				}

				if (cmd === 'on') {
					block.sliderAutoPlay = 'true'
					storeAnimate.set('true')
				}
				storeData.set(config)
			}
		})
	}

	const set_inset_title_font = (e) => {
		const font = e.detail.font
		set_css_tag(font, 'fontTitle')
	}

	const set_inset_title_size = (e) => {
		const sizestr = e.detail.size
		const size = string_to_fontsize(sizestr)
		set_css_tag(size, 'sizeTitle')
	}

	const set_inset_text_font = (e) => {
		const font = e.detail.font
		set_css_tag(font, 'fontText')
	}

	const set_inset_text_size = (e) => {
		const sizestr = e.detail.size
		const size = string_to_fontsize(sizestr)
		set_css_tag(size, 'sizeText')
	}

	const change_order = async (block, direction) => {
		let changeOrder = true
		blocks = get_blocks(config)
		blocks.forEach((bl) => {
			if (bl.blockName === block && bl.layoutOrder === 0 && direction === 'up') {
				changeOrder = false
			}

			if (bl.blockName === block && bl.layoutOrder === blocks.length - 1 && direction === 'down') {
				changeOrder = false
			}
		})
		if (changeOrder) {
			shaderChangeOrder = true
			const reorder = await reorder_layout(block, direction)
			if (reorder !== 'examples') {
				blocks = get_blocks(config)
				config.blocks = blocks
				storeData.set(reorder)
				shaderChangeOrder = false
			}
		}
	}

	//timeout (wait until subTool is loaded)
	let toTool
	const open_tool = (t) => {
		switch (t) {
			case 'generalTool1':
				generalTool1 = generalTool1 === true ? false : true
				showTool3 = false
				showTool4 = false
				break

			case 'generalTool2':
				generalTool2 = generalTool2 === true ? false : true
				showTool6 = false
				showTool7 = false
				showTool8 = false
				showTool9 = false
				break

			case 0:
				showTool0 = showTool0 === true ? false : true
				showTool1 = false
				showTool2 = false
				showTool5 = false
				break

			case 1:
				showTool1 = showTool1 === true ? false : true
				showTool0 = false
				showTool2 = false
				showTool5 = false
				break

			case 2:
				showTool2 = showTool2 === true ? false : true
				showTool1 = false
				showTool0 = false
				showTool5 = false
				break

			case 3:
				showTool3 = showTool3 === true ? false : true
				showTool4 = false
				generalTool1 = false
				if (showTool3) {
					if (!icon1) icon1Color = iconColor
					if (!icon2) icon2Color = iconColor
					if (!icon3) icon3Color = iconColor
					if (!icon4) icon4Color = iconColor
					if (!icon1 || !icon2 || !icon3 || !icon4) icon5Color = iconColor

					toTool = setTimeout(() => {
						icon1Color = icon1Color
						icon2Color = icon2Color
						icon3Color = icon3Color
						icon4Color = icon4Color
						icon5Color = icon5Color
					}, 10)
				}
				break

			case 4:
				showTool4 = showTool4 === true ? false : true
				showTool3 = false
				generalTool1 = false
				break

			case 5:
				showTool5 = showTool5 === true ? false : true
				showTool1 = false
				showTool2 = false
				showTool0 = false
				break

			case 6:
				showTool6 = showTool6 === true ? false : true
				generalTool2 = false
				showTool7 = false
				showTool8 = false
				showTool9 = false
				if (showTool6) {
					if (!icon6) icon6Color = iconColor
					if (!icon7) icon7Color = iconColor
					if (!icon8) icon8Color = iconColor
					if (!icon9) icon9Color = iconColor
					if (!icon6 || !icon7 || !icon8 || !icon9) icon10Color = iconColor

					toTool = setTimeout(() => {
						icon6Color = icon6Color
						icon7Color = icon7Color
						icon8Color = icon8Color
						icon9Color = icon9Color
						icon10Color = icon10Color
					}, 10)
				}
				break

			case 7:
				showTool7 = showTool7 === true ? false : true
				showTool6 = false
				showTool9 = false
				showTool8 = false
				generalTool2 = false
				break

			case 8:
				showTool8 = showTool8 === true ? false : true
				showTool7 = false
				showTool9 = false
				showTool6 = false
				generalTool2 = false
				break

			case 9:
				showTool9 = showTool9 === true ? false : true
				showTool7 = false
				showTool8 = false
				showTool6 = false
				generalTool2 = false
				break
		}
	}

	onDestroy(() => {
		stoElementID
		stoData
		stoSelectedIcon
		stoAnimate
		clearTimeout(toTool)
	})
</script>

{#if config}
	<main use:styles={{ width }}>
		<div
			class="part_title mainTool"
			on:click={() => open_tool(0)}
			on:keydown={() => open_tool(0)}
			use:styles={{ mainTool, mainToolHover, fsXS }}
		>
			LAYOUT POSITION
		</div>
		{#if showTool0}
			<div transition:slide={{ duration: 500 }}>
				<div class="icon_container">
					<div
						class="icon arrow_down"
						use:styles={{ icon, iconColor, iconHover }}
						on:click={() => change_order(blockID, 'down')}
						on:keydown={() => change_order(blockID, 'down')}
					/>
					<div
						class="icon arrow_up"
						use:styles={{ icon, iconColor, iconHover }}
						on:click={() => change_order(blockID, 'up')}
						on:keydown={() => change_order(blockID, 'up')}
					/>
				</div>
			</div>
		{/if}

		<div
			class="part_title mainTool"
			on:click={() => open_tool(1)}
			on:keydown={() => open_tool(1)}
			use:styles={{ mainTool, mainToolHover, fsXS }}
		>
			BEHAVIOR
		</div>
		{#if showTool1}
			<div transition:slide={{ duration: 500 }}>
				<div class="sub_title" use:styles={{ fsS }}>Direction</div>
				<div class="icon_container">
					<div class="icon_container">
						<div
							id="arrLeft"
							class="icon arrow_left"
							use:styles={{ icon, iconColor, iconHover }}
							on:click={() => change_direction('left')}
							on:keydown={() => change_direction('left')}
						/>
						<div
							id="arrRight"
							class="icon arrow_right"
							use:styles={{ icon, iconColor, iconHover }}
							on:click={() => change_direction('right')}
							on:keydown={() => change_direction('right')}
						/>

						{#if autoplay === 'true'}
							<button on:click={() => auto_play('off')} use:styles={{ fsXS }}>off</button>
						{:else}
							<button on:click={() => auto_play('on')} use:styles={{ fsXS }}>on</button>
						{/if}
					</div>
				</div>
				{#if autoplay === 'true'}
					<div class="sub_title_small" use:styles={{ fsXS }}>Speed</div>
					<SizeSelector
						ID={idSliderSpeed}
						showUnit={false}
						range="5"
						initialValue={selectedSpeed}
						on:sizechange={change_speed}
					/>

					<div class="sub_title_small" use:styles={{ fsXS }}>Pause</div>
					<SizeSelector
						ID={idSliderPause}
						showUnit={false}
						range="5"
						initialValue={selectedPause}
						on:sizechange={change_pause}
					/>
				{:else}
					<div class="sub_title_small" use:styles={{ fsXS }}>Control Color</div>
					<ColorSelector
						on:setcolor={set_control_color}
						showTranparency={false}
						ID={idColor9}
						selectedColor={controlColor}
					/>
					<div class="sub_title_small" use:styles={{ fsXS }}>Control Hover</div>
					<ColorSelector
						on:setcolor={set_control_hover}
						showTranparency={false}
						ID={idColor10}
						selectedColor={controlHover}
					/>
				{/if}
			</div>
		{/if}

		<div
			class="part_title mainTool"
			on:click={() => open_tool(2)}
			on:keydown={() => open_tool(2)}
			use:styles={{ mainTool, mainToolHover, fsXS }}
		>
			CONTAINER
		</div>
		{#if showTool2}
			<div transition:slide={{ duration: 500 }}>
				<div
					class="part_title subTool"
					on:click={() => open_tool('generalTool1')}
					on:keydown={() => open_tool('generalTool1')}
					use:styles={{ subTool, subToolHover, fsXS }}
				>
					general
				</div>
				{#if generalTool1}
					<div transition:slide={{ duration: 500 }}>
						<div class="sub_title_small" use:styles={{ fsXS }}>Background</div>
						<ColorSelector
							on:setcolor={set_bg_color}
							on:setopacity={set_bg_color}
							on:settransparent={set_bg_color}
							ID={idColor1}
							transparent="1"
							selectedColor={selectedBackground}
							initialValue={selectedBgOpac}
						/>
						<div class="sub_title_small" use:styles={{ fsXS }}>Width</div>
						<SizeSelector
							ID={idSliderWidth}
							initialValue={selectedSliderWidth}
							range="100"
							unit="%"
							on:sizechange={set_slider_width}
						/>

						<div class="sub_title_small" use:styles={{ fsXS }}>Height</div>
						<SizeSelector
							ID={idSliderHeight}
							initialValue={selectedSliderHeight}
							range="100"
							unit="%"
							on:sizechange={set_slider_height}
						/>
						<div class="sub_title_small" use:styles={{ fsXS }}>Margin Top</div>
						<SizeSelector ID={idMarginTop} range="20" initialValue={selectedMarginTop} on:sizechange={set_margin_top} />

						<div class="sub_title_small" use:styles={{ fsXS }}>Margin Bottom</div>
						<SizeSelector
							ID={idMarginBottom}
							range="20"
							initialValue={selectedMarginBottom}
							on:sizechange={set_margin_bottom}
						/>

						<div class="sub_title_small" use:styles={{ fsXS }}>Padding</div>
						<SizeSelector ID={idPadding} range="5" initialValue={selectedPadding} on:sizechange={set_padding} />
					</div>
				{/if}
				<div
					class="part_title subTool"
					on:click={() => open_tool(3)}
					on:keydown={() => open_tool(3)}
					use:styles={{ subTool, subToolHover, fsXS }}
				>
					border
				</div>
				{#if showTool3}
					<div transition:slide={{ duration: 500 }}>
						<div class="sub_title_small" use:styles={{ fsXS }}>Border</div>
						<div class="icon_container">
							<div
								id="icon1"
								class="icon icon1"
								use:styles={{ icon, icon1Color, iconHover }}
								on:click={set_icon_1}
								on:keydown={set_icon_1}
							/>
							<div
								id="icon2"
								class="icon icon2"
								use:styles={{ icon, icon2Color, iconHover }}
								on:click={set_icon_2}
								on:keydown={set_icon_2}
							/>
							<div
								id="icon3"
								class="icon icon3"
								use:styles={{ icon, icon3Color, iconHover }}
								on:click={set_icon_3}
								on:keydown={set_icon_3}
							/>
							<div
								id="icon4"
								class="icon icon4"
								use:styles={{ icon, icon4Color, iconHover }}
								on:click={set_icon_4}
								on:keydown={set_icon_4}
							/>
							<div
								id="icon5"
								class="icon icon5"
								use:styles={{ icon, icon5Color, iconHover }}
								on:click={set_icon_5}
								on:keydown={set_icon_5}
							/>
						</div>
						{#if iconSelected}
							<div in:slide={{ duration: 500 }}>
								<div class="sub_title" use:styles={{ fsS }}>Border Color</div>
								<ColorSelector
									on:setcolor={set_border_color}
									on:setopacity={set_border_color}
									ID={idColor2}
									selectedColor={selectedBorderColor}
									initialValue={selectedBgOpac}
								/>

								<div class="sub_title" use:styles={{ fsS }}>Border Width</div>
								<SizeSelector
									ID={idBorderWidth}
									range="50"
									unit="px"
									initialValue={selectedBorderWidth}
									on:sizechange={set_border_width}
								/>

								<div class="sub_title" use:styles={{ fsS }}>Border Top Radius</div>
								<SizeSelector
									ID={idBTradius}
									unit="px"
									initialValue={selectedSBTradius}
									range="20"
									on:sizechange={set_border_top_radius}
								/>

								<div class="sub_title" use:styles={{ fsS }}>Border Bottom Radius</div>
								<SizeSelector
									ID={idBBradius}
									initialValue={selectedSBBradius}
									range="20"
									unit="px"
									on:sizechange={set_border_bottom_radius}
								/>
							</div>
						{/if}
					</div>
				{/if}

				<div
					class="part_title subTool"
					on:click={() => open_tool(4)}
					on:keydown={() => open_tool(4)}
					use:styles={{ subTool, subToolHover, fsXS }}
				>
					shadow
				</div>
				{#if showTool4}
					<div transition:slide={{ duration: 500 }}>
						<div class="sub_title" use:styles={{ fsS }}>Color</div>
						<ColorSelector
							on:setcolor={set_slider_shadow_color}
							on:setopacity={set_slider_shadow_color}
							ID={idColor7}
							selectedColor={selectedSliderShadowColor}
							initialValue={selectedSliderShadowOpac}
						/>
						<div class="sub_title_small" use:styles={{ fsXS }}>Offset X</div>
						<SizeSelector
							ID={idSliderOffsetX}
							initialValue={selectedSliderShadowX}
							range="20"
							unit="px"
							on:sizechange={set_slider_offset_x}
						/>

						<div class="sub_title_small" use:styles={{ fsXS }}>Offset Y</div>
						<SizeSelector
							ID={idSliderOffsetY}
							initialValue={selectedSliderShadowY}
							range="20"
							unit="px"
							on:sizechange={set_slider_offset_y}
						/>

						<div class="sub_title_small" use:styles={{ fsXS }}>Blur</div>
						<SizeSelector
							ID={idSliderBlur}
							initialValue={selectedSliderShadowBlur}
							range="20"
							unit="px"
							on:sizechange={set_slider_blur}
						/>
					</div>
				{/if}
			</div>
		{/if}

		<div
			class="part_title mainTool"
			on:click={() => open_tool(5)}
			on:keydown={() => open_tool(5)}
			use:styles={{ mainTool, mainToolHover, fsXS }}
		>
			INSET CONTAINER
		</div>
		{#if showTool5}
			<div transition:slide={{ duration: 500 }}>
				<div
					class="part_title subTool"
					on:click={() => open_tool('generalTool2')}
					on:keydown={() => open_tool('generalTool2')}
					use:styles={{ subTool, subToolHover, fsXS }}
				>
					general
				</div>
				{#if generalTool2}
					<div transition:slide={{ duration: 500 }}>
						<div class="sub_title_small" use:styles={{ fsXS }}>background</div>
						<ColorSelector
							on:setcolor={set_inset_bg_color}
							on:setopacity={set_inset_bg_color}
							on:settransparent={set_inset_bg_color}
							transparent="1"
							ID={idColor3}
							selectedColor={selectedInsetBackground}
							initialValue={selectedInsetBgOpac}
						/>
						<div class="sub_title_small" use:styles={{ fsXS }}>width</div>
						<SizeSelector
							ID={idInsetWidth}
							initialValue={selectedInsetWidth}
							range="100"
							unit="%"
							on:sizechange={set_inset_width}
						/>

						<div class="sub_title_small" use:styles={{ fsXS }}>height</div>
						<SizeSelector
							ID={idInsetHeight}
							initialValue={selectedInsetHeight}
							range="100"
							on:sizechange={set_inset_height}
						/>

						<div class="sub_title_small" use:styles={{ fsXS }}>left</div>
						<SizeSelector
							ID={idInsetLeft}
							initialValue={selectedInsetLeft}
							range="100"
							unit="%"
							on:sizechange={set_inset_left}
						/>

						<div class="sub_title_small" use:styles={{ fsXS }}>top</div>
						<SizeSelector
							ID={idInsetTop}
							initialValue={selectedInsetTop}
							range="20"
							unit="%"
							on:sizechange={set_inset_top}
						/>
					</div>
				{/if}

				<div
					class="part_title subTool"
					on:click={() => open_tool(6)}
					on:keydown={() => open_tool(6)}
					use:styles={{ subTool, subToolHover, fsXS }}
				>
					border
				</div>
				{#if showTool6}
					<div transition:slide={{ duration: 500 }}>
						<div class="icon_container">
							<div
								id="icon6"
								class="icon icon6"
								use:styles={{ icon, icon6Color, iconHover }}
								on:click={set_icon_6}
								on:keydown={set_icon_6}
							/>
							<div
								id="icon7"
								class="icon icon7"
								use:styles={{ icon, icon7Color, iconHover }}
								on:click={set_icon_7}
								on:keydown={set_icon_7}
							/>
							<div
								id="icon8"
								class="icon icon8"
								use:styles={{ icon, icon8Color, iconHover }}
								on:click={set_icon_8}
								on:keydown={set_icon_8}
							/>
							<div
								id="icon9"
								class="icon icon9"
								use:styles={{ icon, icon9Color, iconHover }}
								on:click={set_icon_9}
								on:keydown={set_icon_9}
							/>
							<div
								id="icon10"
								class="icon icon10"
								use:styles={{ icon, icon10Color, iconHover }}
								on:click={set_icon_10}
								on:keydown={set_icon_10}
							/>
						</div>
						{#if iconIselected}
							<div in:slide={{ duration: 500 }}>
								<div class="sub_title" use:styles={{ fsS }}>Border Color</div>
								<ColorSelector
									on:setcolor={set_inset_border_color}
									on:setopacity={set_inset_border_color}
									ID={idColor4}
									selectedColor={selectedBorderColor}
									initialValue={selectedInsetBgOpac}
								/>

								<div class="sub_title" use:styles={{ fsS }}>Border Width</div>
								<SizeSelector
									ID={idInsetBorderWidth}
									range="20"
									unit="px"
									initialValue={selectedInsetBorderWidth}
									on:sizechange={set_inset_border_width}
								/>

								<div class="sub_title" use:styles={{ fsS }}>Border Top Radius</div>

								<SizeSelector
									ID={idInsetBTradius}
									range="20"
									unit="px"
									initialValue={selectedITradius}
									on:sizechange={set_inset_border_top_radius}
								/>

								<div class="sub_title" use:styles={{ fsS }}>Border Bottom Radius</div>
								<SizeSelector
									ID={idInsetBBradius}
									initialValue={selectedIBradius}
									range="20"
									unit="px"
									on:sizechange={set_inset_border_bottom_radius}
								/>
							</div>
						{/if}
					</div>
				{/if}

				<div
					class="part_title subTool"
					on:click={() => open_tool(7)}
					on:keydown={() => open_tool(7)}
					use:styles={{ subTool, subToolHover, fsXS }}
				>
					shadow
				</div>
				{#if showTool7}
					<div transition:slide={{ duration: 500 }}>
						<div class="sub_title" use:styles={{ fsS }}>Color</div>
						<ColorSelector
							on:setcolor={set_slider_window_shadow_color}
							on:setopacity={set_slider_window_shadow_color}
							ID={idColor8}
							selectedColor={selectedSliderInsetShadowColor}
							initialValue={selectedSliderInsetShadowOpac}
						/>
						<div class="sub_title_small" use:styles={{ fsXS }}>Offset X</div>
						<SizeSelector
							ID={idSliderInsetOffsetX}
							initialValue={selectedSliderInsetShadowX}
							range="20"
							unit="px"
							on:sizechange={set_slider_inset_offset_x}
						/>

						<div class="sub_title_small" use:styles={{ fsXS }}>Offset Y</div>
						<SizeSelector
							ID={idSliderInsetOffsetY}
							initialValue={selectedSliderInsetShadowY}
							range="20"
							unit="px"
							on:sizechange={set_slider_inset_offset_y}
						/>

						<div class="sub_title_small" use:styles={{ fsXS }}>Blur</div>
						<SizeSelector
							ID={idSliderInsetBlur}
							initialValue={selectedSliderInsetShadowBlur}
							range="20"
							unit="px"
							on:sizechange={set_slider_inset_blur}
						/>
					</div>
				{/if}

				<div
					class="part_title subTool"
					on:click={() => open_tool(8)}
					on:keydown={() => open_tool(8)}
					use:styles={{ subTool, subToolHover, fsXS }}
				>
					font title
				</div>
				{#if showTool8}
					<div transition:slide={{ duration: 500 }}>
						<div class="sub_title_small" use:styles={{ fsXS }}>Font Color</div>
						<ColorSelector
							on:setcolor={set_inset_title_color}
							on:setopacity={set_inset_title_color}
							ID={idColor5}
							selectedColor={selectedItitleColor}
							initialValue={selectedItitleOpac}
						/>
						<div class="sub_title_small" use:styles={{ fsXS }}>Font Family</div>
						<SelectValues
							options={fontFamily}
							on:select={set_inset_title_font}
							value={selectedItitleFont}
							ID={idSelect1}
						/>
						<div class="sub_title_small" use:styles={{ fsXS }}>Font Size</div>
						<SelectValues
							options={fontSize}
							on:select={set_inset_title_size}
							value={selectedItitleSize}
							ID={idSelect2}
						/>
						<div class="sub_title_small" use:styles={{ fsXS }}>Font Decoration</div>
						<div class="icon_container">
							<div
								id="fweight"
								class="icon iconTWeight"
								use:styles={{ icon, iconTWeight, iconHover }}
								on:click={set_inset_title_font_weight}
								on:keydown={set_inset_title_font_weight}
							/>
							<div
								id="fstyle"
								class="icon iconTStyle"
								use:styles={{ icon, iconTStyle, iconHover }}
								on:click={set_inset_title_font_style}
								on:keydown={set_inset_title_font_style}
							/>
							<div />
							<div />
						</div>
					</div>
				{/if}

				<div
					class="part_title subTool"
					on:click={() => open_tool(9)}
					on:keydown={() => open_tool(9)}
					use:styles={{ subTool, subToolHover, fsXS }}
				>
					font text
				</div>
				{#if showTool9}
					<div transition:slide={{ duration: 500 }}>
						<div class="sub_title_small" use:styles={{ fsXS }}>Font Color</div>
						<ColorSelector
							on:setcolor={set_inset_text_color}
							on:setopacity={set_inset_text_color}
							ID={idColor6}
							selectedColor={selectedItextColor}
							initialValue={selectedItextOpac}
						/>
						<div class="sub_title_small" use:styles={{ fsXS }}>Font Family</div>
						<SelectValues
							options={fontFamily}
							on:select={set_inset_text_font}
							value={selectedItextFont}
							ID={idSelect3}
						/>
						<div class="sub_title_small" use:styles={{ fsXS }}>Font Size</div>
						<SelectValues options={fontSize} on:select={set_inset_text_size} value={selectedItextSize} ID={idSelect4} />
						<div class="sub_title_small" use:styles={{ fsXS }}>Font Decoration</div>
						<div class="icon_container">
							<div
								id="fweight"
								class="icon iconTXTWeight"
								use:styles={{ icon, iconTXTWeight, iconHover }}
								on:click={set_inset_text_font_weight}
								on:keydown={set_inset_text_font_weight}
							/>
							<div
								id="fstyle"
								class="icon iconTXTStyle"
								use:styles={{ icon, iconTXTStyle, iconHover }}
								on:click={set_inset_text_font_style}
								on:keydown={set_inset_text_font_style}
							/>
							<div />
							<div />
						</div>
						<div class="sub_title_small" use:styles={{ fsXS }}>Font Alignment</div>
						<div class="icon_container">
							<div
								id="falign"
								class="icon iconTLeft"
								use:styles={{ icon, iconTLeft, iconHover }}
								on:click={() => set_inset_text_font_align('left')}
								on:keydown={() => set_inset_text_font_align('left')}
							/>
							<div
								id="falign"
								class="icon iconTCenter"
								use:styles={{ icon, iconTCenter, iconHover }}
								on:click={() => set_inset_text_font_align('center')}
								on:keydown={() => set_inset_text_font_align('center')}
							/>

							<div
								id="falign"
								class="icon iconTRight"
								use:styles={{ icon, iconTRight, iconHover }}
								on:click={() => set_inset_text_font_align('right')}
								on:keydown={() => set_inset_text_font_align('right')}
							/>

							<div
								id="falign"
								class="icon iconTJustify"
								use:styles={{ icon, iconTJustify, iconHover }}
								on:click={() => set_inset_text_font_align('justify')}
								on:keydown={() => set_inset_text_font_align('justify')}
							/>
						</div>
					</div>
				{/if}
			</div>
		{/if}
	</main>
{/if}

{#if shaderChangeOrder}
	<Shader>
		<div slot="content">
			<Spinner color="hsl(0,0%,60%)" info="change block order" />
		</div>
	</Shader>
{/if}

<style>
	main {
		width: var(--with);
		user-select: none;
	}

	button {
		outline: none;
		padding: 5px;
		margin: 0;
		border: 1px solid green;
		width: 70px;
		border-radius: 5px;
		background-color: transparent;
		font-size: var(--fsXS);
		height: 40px;
		margin-left: 10px;
		cursor: pointer;
	}

	button:hover {
		background-color: hsla(0, 0%, 90%, 1);
	}

	.sub_title,
	.sub_title_small {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		background: hsl(0, 0%, 70%);
		color: black;
		font-size: var(--fsS);
		padding: 10px;
	}

	.part_title {
		display: flex;
		width: 100%;
		justify-content: center;
		border-bottom: none;
		font-size: var(--fsXS);
		font-weight: bold;
		background-color: chocolate;
		padding: 10px;
		margin-top: 10px;
		cursor: pointer;
	}

	.sub_title {
		border-bottom: none;
		padding: 10px 0px 3px 10px;
		border-bottom: none;
	}

	.sub_title_small {
		font-size: var(--fsXS);
		padding: 5px 0px 0px 10px;
	}

	.icon_container {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(40px, 1fr));
		padding: 2%;
	}

	.icon {
		display: inline-block;
		width: var(--icon);
		height: var(--icon);
		mask-size: cover;
		-webkit-mask-size: cover;
		cursor: pointer;
	}

	.icon:hover {
		background-color: var(--iconHover);
	}

	.arrow_down {
		background-color: var(--iconColor);
		mask: url('/images/tools/arrow_down.svg') no-repeat;
		-webkit-mask: url('/images/tools/arrow_down.svg') no-repeat;
	}

	.arrow_up {
		background-color: var(--iconColor);
		mask: url('/images/tools/arrow_up.svg') no-repeat;
		-webkit-mask: url('/images/tools/arrow_up.svg') no-repeat;
	}

	.icon1,
	.icon6 {
		mask: url('/images/tools/borderL.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderL.svg') no-repeat;
	}

	.icon1 {
		background-color: var(--icon1Color);
	}

	.icon6 {
		background-color: var(--icon6Color);
	}

	.icon2,
	.icon7 {
		mask: url('/images/tools/borderT.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderT.svg') no-repeat;
	}

	.icon2 {
		background-color: var(--icon2Color);
	}

	.icon7 {
		background-color: var(--icon7Color);
	}

	.icon3,
	.icon8 {
		mask: url('/images/tools/borderR.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderR.svg') no-repeat;
	}

	.icon3 {
		background-color: var(--icon3Color);
	}

	.icon8 {
		background-color: var(--icon8Color);
	}

	.icon4,
	.icon9 {
		mask: url('/images/tools/borderB.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderB.svg') no-repeat;
	}

	.icon4 {
		background-color: var(--icon4Color);
	}

	.icon9 {
		background-color: var(--icon9Color);
	}

	.icon5,
	.icon10 {
		mask: url('/images/tools/borderA.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderA.svg') no-repeat;
	}

	.icon5 {
		background-color: var(--icon5Color);
	}

	.icon10 {
		background-color: var(--icon10Color);
	}

	.arrow_left {
		background-color: var(--iconColor);
		mask: url('/images/tools/arrowL.svg') no-repeat;
		-webkit-mask: url('/images/tools/arrowL.svg') no-repeat;
	}

	.arrow_right {
		background-color: var(--iconColor);
		mask: url('/images/tools/arrowR.svg') no-repeat;
		-webkit-mask: url('/images/tools/arrowR.svg') no-repeat;
	}

	.iconTWeight {
		background-color: var(--iconTWeight);
		mask: url('/images/tools/fontB.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontB.svg') no-repeat;
	}

	.iconTLeft {
		background-color: var(--iconTLeft);
		mask: url('/images/tools/alignL.svg') no-repeat;
		-webkit-mask: url('/images/tools/alignL.svg') no-repeat;
	}

	.iconTCenter {
		background-color: var(--iconTCenter);
		mask: url('/images/tools/alignC.svg') no-repeat;
		-webkit-mask: url('/images/tools/alignC.svg') no-repeat;
	}

	.iconTJustify {
		background-color: var(--iconTJustify);
		mask: url('/images/tools/alignJ.svg') no-repeat;
		-webkit-mask: url('/images/tools/alignJ.svg') no-repeat;
	}

	.iconTRight {
		background-color: var(--iconTRight);
		mask: url('/images/tools/alignR.svg') no-repeat;
		-webkit-mask: url('/images/tools/alignR.svg') no-repeat;
	}

	.iconTStyle {
		background-color: var(--iconTStyle);
		mask: url('/images/tools/fontI.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontI.svg') no-repeat;
	}

	.iconTXTWeight {
		background-color: var(--iconTXTWeight);
		mask: url('/images/tools/fontB.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontB.svg') no-repeat;
	}

	.iconTXTStyle {
		background-color: var(--iconTXTStyle);
		mask: url('/images/tools/fontI.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontI.svg') no-repeat;
	}

	.mainTool {
		background-color: var(--mainTool);
	}

	.mainTool:hover {
		background-color: var(--mainToolHover);
	}

	.subTool {
		background-color: var(--subTool);
	}

	.subTool:hover {
		background-color: var(--subToolHover);
	}
</style>
